<template>
  <v-app>
    <changelog></changelog>
    <v-snackbar v-model="snack" :timeout="-1" color="primary">
      <div class="d-flex flex-row align-center" style="gap: 12px">
        <div>
          Estaremos realizando tareas mayores de actualización a lo largo del
          día. <br />
          Pueden acontecer algunas turbulencias.
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <Navbar v-if="currentUser && navbar" />
    <AppBar v-if="currentUser && !noSidebar" />
    <v-main class="background">
      <!-- global content layout: every view (except full-bleed/no-sidebar ones like
           login) is centered + capped + padded here, so views don't set their own -->
      <div :class="{ 'app-content': !noSidebar }">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </div>
    </v-main>

    <v-snackbar
      bottom
      :value="updateExists"
      :timeout="-1"
      light
      color="grey lighten-3"
    >
      Nuevo contenido disponible.
      <v-btn small @click="refreshApp" color="primary" class="ml-6">
        Actualizar
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import update from "./mixins/update";
import AppBar from "./components/AppBar";
import Navbar from "@/components/Navbar";
import Changelog from "@/components/shared/Changelog";
import { mapGetters } from "vuex";
import { SigninUser } from "@/graphql/mutations/user";
import { TokenService } from "@/services/storageService";

export default {
  name: "App",

  data: () => ({
    noSidebar: null,
    navbar: null,
    snack: true,
    alert: {
      active: false
    }
  }),

  components: {
    AppBar,
    Navbar,
    Changelog
  },

  mixins: [update],

  methods: {
    activateAlert(type, message) {
      this.alert.active = true;
      this.alert.type = type;
      this.alert.message = message;
      window.setInterval(() => {
        this.alert.active = false;
      }, 5000);
    }
  },

  computed: {
    ...mapGetters(["currentUser", "isLoggedIn"])
  },

  watch: {
    $route(to, from) {
      this.noSidebar = to.meta.noSidebar;
      this.navbar = to.meta.navbar;

      if (!this.currentUser && TokenService.getToken()) {
        this.signIn();
      }
    },

    currentUser() {
      if (this.currentUser && !this.currentUser.selectedAgency) {
        this.$router.go();
      }
    }
  },

  created() {
    this.noSidebar = this.$route.meta.noSidebar;
    this.navbar = this.$route.meta.navbar;

    this.snack = !localStorage.getItem("hideSnack");
  },

  mounted() {
    const theme = localStorage.getItem("useDarkTheme");
    if (theme) {
      this.$vuetify.theme.dark = theme == "true";
    }

    if (!this.currentUser && this.isLoggedIn) {
      this.signIn();
    }
  },

  methods: {
    signIn() {
      this.$apollo
        .mutate({
          mutation: SigninUser,
          variables: {
            input: {
              token: TokenService.getToken()
            }
          }
        })
        .then(res => {
          let data = res.data.signIn;
          if (data.token) {
            TokenService.saveToken(data.token);
            this.$store.commit("setCurrentUser", data.user);
          } else {
            console.log(res);
            TokenService.removeToken();
          }
        })
        .catch(errors => {
          console.log(errors);
          TokenService.removeToken();
        });
    },

    close() {
      localStorage.setItem("hideSnack", true);
      this.snack = false;
    }
  }
};
</script>
<style scoped>
/* global content layout — centered, capped, padded. Every sidebar view sticks
   to this; views should NOT set their own max-width / margin / page padding. */
.app-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 56px;
}
@media (max-width: 600px) {
  .app-content { padding: 18px 16px 40px; }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
/* Global button language: the whole CRM uses warm sentence-case buttons.
   Vuetify defaults v-btn to UPPERCASE + wide letter-spacing, which clashed with
   the Sartor look and made each redesigned page's buttons read differently
   ("GUARDAR" vs "Nuevo miembro"). This unifies every v-btn app-wide. */
.v-application .v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}
</style>
